(function() {
  'use strict';

  const SELECTORS = {
    root: '[data-simple-anyseal-picker]',
    add: '[data-simple-anyseal-set-add]',
    addText: '[data-simple-anyseal-set-add-text]',
    status: '[data-simple-anyseal-set-status]',
    infoOpen: '[data-simple-anyseal-info-open]',
    modal: '[data-simple-anyseal-set-modal]',
    modalOpen: '[data-simple-anyseal-set-modal][data-open="true"]',
    modalClose: '[data-simple-anyseal-modal-close]'
  };

  const getScopeRoot = function() {
    return (
      document.querySelector('quick-view-drawer details[open]') ||
      document.querySelector('quick-view-drawer details.menu-opening') ||
      document.querySelector('.quick-view--open') ||
      document.querySelector('.quick-view--opening') ||
      document
    );
  };

  const SimpleAnySealRecommendations = {
    keydownHandler: null,

    init: function(root) {
      const scope = root || getScopeRoot();
      scope.querySelectorAll(SELECTORS.root).forEach((container) => {
        if (container.dataset.simpleAnysealInitialized === 'true') return;
        container.dataset.simpleAnysealInitialized = 'true';
        this.bindEvents(container);
      });
    },

    bindEvents: function(container) {
      container.addEventListener('click', (event) => {
        const closeModalButton = event.target.closest(SELECTORS.modalClose);
        if (closeModalButton && container.contains(closeModalButton)) {
          event.preventDefault();
          this.closeSetModal(closeModalButton.closest(SELECTORS.modal));
          return;
        }

        const infoButton = event.target.closest(SELECTORS.infoOpen);
        if (infoButton && container.contains(infoButton)) {
          event.preventDefault();
          this.openSetModal(infoButton, container);
          return;
        }

        const addButton = event.target.closest(SELECTORS.add);
        if (!addButton || !container.contains(addButton)) return;

        event.preventDefault();
        this.addSetToCart(addButton, container);
      });

      if (!this.keydownHandler) {
        this.keydownHandler = (event) => {
          if (event.key !== 'Escape') return;
          this.closeSetModal(document.querySelector(SELECTORS.modalOpen));
        };
        document.addEventListener('keydown', this.keydownHandler);
      }
    },

    getCartAddUrl: function() {
      const routes = window.theme && window.theme.routes ? window.theme.routes : {};
      const rootUrl = routes.root_url || '/';
      const normalizedRoot = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
      return normalizedRoot + '/cart/add.js';
    },

    openSetModal: function(button, container) {
      const modalId = button.getAttribute('aria-controls');
      if (!modalId) return;

      const modal = document.getElementById(modalId);
      if (!modal || !container.contains(modal)) return;

      this.closeSetModal(container.querySelector(SELECTORS.modalOpen), false);

      modal.hidden = false;
      modal.dataset.open = 'true';
      modal._simpleAnysealOpener = button;
      button.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('simple-anyseal-modal-is-open');

      window.requestAnimationFrame(() => {
        const focusTarget = modal.querySelector('.simple-anyseal-set-modal__close') || modal.querySelector('[role="dialog"]');
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus();
        }
      });
    },

    closeSetModal: function(modal, restoreFocus = true) {
      if (!modal) return;

      const opener = modal._simpleAnysealOpener || document.querySelector(`[aria-controls="${modal.id}"]`);
      modal.hidden = true;
      delete modal.dataset.open;

      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }

      if (!document.querySelector(SELECTORS.modalOpen)) {
        document.documentElement.classList.remove('simple-anyseal-modal-is-open');
      }

      if (restoreFocus && opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    },

    addSetToCart: function(button, container) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.disabled) return;

      const label = button.querySelector(SELECTORS.addText);
      const status = container.querySelector(SELECTORS.status);
      const originalText = label ? label.textContent : '';
      const cart = document.querySelector('mini-cart');
      const formData = new FormData();
      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };

      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);

        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(button);
        }
      }

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = container.dataset.labelAdding || '';
      if (status) status.textContent = '';

      fetch(this.getCartAddUrl(), config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message || 'Add to cart failed');
          }

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'simple-anyseal-recommendations',
              productVariantId: variantId,
              cartData: response
            });
          }

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          if (label) label.textContent = container.dataset.labelAdded || '';
          if (status) status.textContent = container.dataset.messageAdded || '';

          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-added');
            if (label) label.textContent = originalText || container.dataset.labelAdd || '';
          }, 1800);
        })
        .catch((error) => {
          if (window.Shopify && window.Shopify.designMode) {
            console.warn('[SimpleAnySealRecommendations] Set could not be added to cart', error);
          }

          button.disabled = false;
          button.classList.remove('is-loading');
          if (label) label.textContent = originalText || container.dataset.labelAdd || '';
          if (status) status.textContent = container.dataset.messageError || '';
        });
    }
  };

  window.SimpleAnySealRecommendations = SimpleAnySealRecommendations;

  const initialize = function(event) {
    SimpleAnySealRecommendations.init(event && event.target instanceof Element ? event.target : getScopeRoot());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('quickview:loaded', initialize);
  document.addEventListener('product-info:loaded', initialize);
})();
